import { IonButton, IonCol, IonGrid, IonRow } from "@ionic/react";

import styles from "@components/fieldsNative/ButtonThatLooksLikeASelect.module.css";
import Icon from "@components/text/Icon";
import BodyCopy from "@components/typography/BodyCopy";

type Props = React.ComponentProps<typeof IonButton>;

const ButtonThatLooksLikeASelect = ({ children, className, ...ionButtonProps }: Props) => {
  const classNames = [styles.fakeSelect];
  if (className) {
    classNames.push(className);
  }

  return (
    // eslint-disable-next-line react/forbid-elements
    <IonButton className={classNames.join(" ")} {...ionButtonProps}>
      <IonGrid>
        <IonRow>
          <IonCol>
            <div className={`ion-text-start ${styles.fakeSelectText}`}>
              <BodyCopy color="gray-500">{children}</BodyCopy>
            </div>
          </IonCol>
          <IonCol size="auto">
            <Icon color="gray" icon="chevronDown" />
          </IonCol>
        </IonRow>
      </IonGrid>
    </IonButton>
  );
};

export default ButtonThatLooksLikeASelect;
